import { JwtUser } from "@funcional/react-auth-ui";

/**
 * Checa as permissões de acesso do usuário logado.
 */
export const fetchPermission =
  (user: JwtUser) =>
  // Exemplo: `permission` pode ser "list.program", ou "create.user"
  async (permission: string): Promise<boolean> => {
    let allowed = false;

    // Por padrão usuários master e pharma_benefit_manager fazen tudo
    // e support pode dar "list" e "show" em tudo, mas não create, update, etc.
    if (
      user.hasAnyOfTheseSsoRoles("master", "support", "pharma_benefit_manager")
    ) {
      // read only
      if (["list", "show"].includes(permission.split(".")[0])) {
        allowed = true;
      }

      // create, update and delete
      if (user.hasAnyOfTheseSsoRoles("master", "pharma_benefit_manager")) {
        allowed = true;
      }
    }

    // Promessa, caso seja necessário consultar uma API... nesse caso use cache!
    return Promise.resolve(allowed);
  };
